// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1DatabaseMode = {
  ModePrimary: 'PRIMARY',
  ModeSecondary: 'SECONDARY',
} as const;
export type V1DatabaseMode =
  (typeof V1DatabaseMode)[keyof typeof V1DatabaseMode];

export function instanceOfV1DatabaseMode(value: any): boolean {
  for (const key in V1DatabaseMode) {
    if (Object.prototype.hasOwnProperty.call(V1DatabaseMode, key)) {
      if (V1DatabaseMode[key as keyof typeof V1DatabaseMode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V1DatabaseModeFromJSON(json: any): V1DatabaseMode {
  return V1DatabaseModeFromJSONTyped(json, false);
}

export function V1DatabaseModeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1DatabaseMode {
  return json as V1DatabaseMode;
}

export function V1DatabaseModeToJSON(value?: V1DatabaseMode | null): any {
  return value as any;
}

export function V1DatabaseModeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1DatabaseMode {
  return value as V1DatabaseMode;
}
